export default __webpack_public_path__ + "static/media/12.7e8ad29f.jpg";